import React from "react";
import { Avatar, Typography, Icon } from "antd";
const { Text } = Typography;
import styles from "./styles.module.scss";
import { UserOutlined } from "@ant-design/icons";

const UserInforContent = ({ user, children }) => {
  return (
    <div className={styles.userContainer}>
      <div>
        <Avatar icon={<UserOutlined />} className={styles.avatarIconContainer}/>
        <div>
          <Text className={styles.text}>
            {user?.full_name || ""}
          </Text>
          <Text type='secondary'>{user?.email || ""}</Text>
        </div>
      </div>
      {children}
    </div>
  );
};

export default UserInforContent;
